import React, { useState } from "react";

const StoreCard = ({ href, img, alt, children }) => {
  if (!href) return null;

  return (
    <div className="p-2 border text-center ms-2 me-2 bg-white my-auto mb-2 rounded-4">
      <a href={href} target="_blank" rel="noreferrer">
        <img className="height-vxs" src={img} alt={alt} />
      </a>
      {children}
    </div>
  );
};

const AmazonFlags = ({ amazonIn, amazonUs, amazonUk }) => {
  return (
    <div className="text-center">
      {amazonIn && (
        <span className="p-1 ms-2 me-2">
          <a href={amazonIn} target="_blank" rel="noreferrer" title="India">
            <img
              className="height-vixs"
              src="https://d3i3lzopayriz.cloudfront.net/others/store_multi_india-oid-1628460312.png"
              alt="Amazon India"
            />
          </a>
        </span>
      )}

      {amazonUs && (
        <span className="p-1 ms-2 me-2">
          <a href={amazonUs} target="_blank" rel="noreferrer" title="USA">
            <img
              className="height-vixs"
              src="https://d3i3lzopayriz.cloudfront.net/others/store_multi_usa-oid-1628324067.png"
              alt="Amazon USA"
            />
          </a>
        </span>
      )}

      {amazonUk && (
        <span className="p-1 ms-2 me-2">
          <a href={amazonUk} target="_blank" rel="noreferrer" title="UK">
            <img
              className="height-vixs"
              src="https://d3i3lzopayriz.cloudfront.net/others/store_multi_uk-oid-1630037756.png"
              alt="Amazon UK"
            />
          </a>
        </span>
      )}
    </div>
  );
};

const Project1636 = () => {
  const [activeLang, setActiveLang] = useState("en");

  // ✅ Leave any unavailable link as "" (empty string) and it will NOT render.
  const LINKS = {
    en: {
      label: "English",
      paperback: {
        amazonIn: "https://www.amazon.in/dp/B0F7H9JD6X",
        amazonUs: "https://www.amazon.com/dp/B0G583XGD9",
        amazonUk: "https://www.amazon.co.uk/dp/B0G583XGD9",
        flipkart: "https://www.flipkart.com/mayan-routes-indian-roots-geopolitical-travelogue-through-central-america-tracing-its-connections-india/p/itm3ed59aef96e25?pid=9798891711426",
        walnut: "https://www.walnutpublication.com/book/9798891712539/",
      },
      ebook: {
        amazonIn: "https://www.amazon.in/dp/B0F7J8KZNS",
        amazonUs: "https://www.amazon.com/dp/B0F7J8KZNS",
        amazonUk: "https://www.amazon.co.uk/dp/B0F7J8KZNS",
        google: "https://play.google.com/store/books/details?id=Ln9bEQAAQBAJ",
      },
    },

    hi: {
      label: "Hindi",
      paperback: {
        amazonIn: "https://www.amazon.in/dp/B0GGZ81YZS",
        amazonUs: "",
        amazonUk: "",
        flipkart: "https://www.flipkart.com/mayan-routes-indian-roots-geopolitical-travelogue-through-central-america-tracing-its-connections-india/p/itm3ed59aef96e25?pid=9798891712546",
        walnut: "https://www.walnutpublication.com/book/9798891712546/",
      },
      ebook: {
        amazonIn: "https://www.amazon.in/dp/B0GHFSR2DT",
        amazonUs: "https://www.amazon.com/dp/B0GHFSR2DT",
        amazonUk: "https://www.amazon.co.uk/dp/B0GHFSR2DT",
        google: "https://play.google.com/store/books/details?id=eyiyEQAAQBAJ",
      },
    },

    es: {
      label: "Spanish",
      paperback: {
        amazonIn: "https://www.amazon.in/dp/B0GGYX6THD",
        amazonUs: "",
        amazonUk: "",
        flipkart: "https://www.flipkart.com/rutas-mayas-races-indias-un-relato-geopoltico-de-viaje-por-centroamrica-y-el-rastreo-sus-conexiones-con-la-india/p/itm62799165b151f?pid=9798891712515",
        walnut: "https://www.walnutpublication.com/book/9798891712515/",
      },
      ebook: {
        amazonIn: "https://www.amazon.in/dp/B0GGZHLTY2",
        amazonUs: "https://www.amazon.com/dp/B0GGZHLTY2",
        amazonUk: "https://www.amazon.co.uk/dp/B0GGZHLTY2",
        google: "https://play.google.com/store/books/details?id=zRmyEQAAQBAJ",
      },
    },
  };

  const lang = LINKS[activeLang];

  const paperbackMainAmazon =
    lang.paperback.amazonIn || lang.paperback.amazonUs || lang.paperback.amazonUk;

  const ebookMainAmazon =
    lang.ebook.amazonIn || lang.ebook.amazonUs || lang.ebook.amazonUk;

  const hasPaperback =
    paperbackMainAmazon || lang.paperback.flipkart || lang.paperback.walnut;

  const hasEbook = ebookMainAmazon || lang.ebook.google;

  return (
    <div
      className="container d-flex flex-column justify-content-center align-items-center"
      style={{ height: "100vh" }}
    >
      {/* Language Tabs */}
      <div className="row w-100 pt-1 pb-1">
        <div className="col-lg-10 offset-lg-1">
          <ul className="nav nav-tabs w-100">
            {Object.entries(LINKS).map(([key, cfg]) => (
              <li className="nav-item flex-fill text-center" key={key}>
                <button
                  type="button"
                  className={`nav-link w-100 ${activeLang === key ? "active" : ""}`}
                  onClick={() => setActiveLang(key)}
                >
                  {cfg.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Paperback */}
      {hasPaperback && (
        <div className="row pt-1 pb-1 w-100">
          <div className="col-lg-10 offset-lg-1">
            <div className="p-3 border-0 mt-4">
              <h2 className="fs-2 text-center mb-3 text-white">
                Paperback ({lang.label})
              </h2>

              <div className="d-flex justify-content-center flex-wrap mt-3">
                <StoreCard
                  href={paperbackMainAmazon}
                  img="https://d3i3lzopayriz.cloudfront.net/others/store_amazon-in-oid-1628460312.png"
                  alt="Amazon Paperback"
                >
                  <AmazonFlags
                    amazonIn={lang.paperback.amazonIn}
                    amazonUs={lang.paperback.amazonUs}
                    amazonUk={lang.paperback.amazonUk}
                  />
                </StoreCard>

                <StoreCard
                  href={lang.paperback.flipkart}
                  img="https://d3i3lzopayriz.cloudfront.net/others/store_flipkart-com-oid-1628324067.png"
                  alt="Flipkart"
                />

                <StoreCard
                  href={lang.paperback.walnut}
                  img="https://s3.ap-south-1.amazonaws.com/vv-zook-public/hq-assets-v1/v3/zfiles/stores/walnutpublication-com-img.png"
                  alt="Walnut Publication"
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* eBook */}
      {hasEbook && (
        <div className="row pt-1 pb-1 w-100">
          <div className="col-lg-10 offset-lg-1">
            <div className="p-3 border-0 mt-4">
              <h2 className="fs-2 text-center mb-3 text-white">
                eBook ({lang.label})
              </h2>

              <div className="d-flex justify-content-center flex-wrap mt-3">
                <StoreCard
                  href={ebookMainAmazon}
                  img="https://d3i3lzopayriz.cloudfront.net/others/store_amazon-kindle-oid-1627683914_1555044434.png"
                  alt="Amazon Kindle"
                >
                  <AmazonFlags
                    amazonIn={lang.ebook.amazonIn}
                    amazonUs={lang.ebook.amazonUs}
                    amazonUk={lang.ebook.amazonUk}
                  />
                </StoreCard>

                <StoreCard
                  href={lang.ebook.google}
                  img="https://d3i3lzopayriz.cloudfront.net/others/store_google-books-oid-1630694165_1555044426.png"
                  alt="Google Books"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Project1636;